import { render, staticRenderFns } from "./penalties.vue?vue&type=template&id=f9db10ca&scoped=true"
import script from "./penalties.vue?vue&type=script&lang=js"
export * from "./penalties.vue?vue&type=script&lang=js"
import style0 from "./penalties.vue?vue&type=style&index=0&id=f9db10ca&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f9db10ca",
  null
  
)

export default component.exports